export const getPictureUrlForTable = (
    product: 'ultimate' | 'standard' | 'off-peak',
) => {
    const pictureUrls = {
        ultimate: '/ywnqh/images/MBT_HOVER_ULTIMATE.svg',
        standard: '/ywnqh/images/MBT_HOVER_STANDARD.svg',
        'off-peak': '/ywnqh/images/MBT_HOVER_OFFPEAK.svg',
    };

    return pictureUrls[product];
};
